<section class="standard-section what-is-{{'id' | translate}}">
  <article class="content-wrap txt-center">
    <app-special-box *ngIf="id!==undefined">
      <h2 class="margin-bottom-40">{{'whatIs.' + id + '.title' | translate}}</h2>
      <p *ngFor="let item of ('whatIs.' + id + '.paragraphs' | translate)" class="arial">
        {{item}}
      </p>
    </app-special-box>
  </article>
</section>
